////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> /detalhe/?prod=                   //
//                                                //
//  PÁGINA PARA VER MAIS FOTOS E OUTROS           //
//  DETALHES DO PRODUTO SELECIONADO               //
//                                                //
//  RECEBE COMO PARÂMETRO NA URL O ID             //
//  DO PRODUTO QUE DEVE SER DETALHADO.            //
//                                                //
//////////////////////////////////////////////////// 



import React, {useState} from "react"

import ContinuarComprando from '../components/continuar_comprando'
import Loader from '../components/loader'
import ItensComprados from  '../components/itens_comprados';

import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import api from "../services/api";


function Detalhe() {

  // ESTADOS DEFINIDOS
    // 'detalhes' = PRODUTOS NO CARRINHO
    // 'fotos' = LISTA DE FOTOS DO PRODUTO
    // 'carrinho' = PRODUTOS NO CARRINHO  

  let [detalhes, setDetalhes] = useState([])
  let [fotos, setFotos] = useState([])
  let [carrinho, setCarrinho] = useState([])


  window.onload = function() {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DESTA PÁGINA ('/detalhe/?prod=')

    carrinho_de_compras()  // DEFINE OS PRODUTOS NO CARRINHO DE COMPRAS

    var params = window.location.search
    var urlparams = new URLSearchParams(params)
    var produto = urlparams.get('prod')

    search_produto(produto)  // BUSCA DETALHES DO PRODUTO
  }

  async function carrinho_de_compras(){  // FUNÇÃO QUE BUSCA OS ITENS DO CARRINHO DE COMPRAS
    // FUNÇÃO CHAMADA PELO ONLOAD DESTA PÁGINA

    if(sessionStorage['login']){  // SE O USUARIO ESTIVER LOGADO
      if(!sessionStorage['login'].includes('/')){  // E NÃO ESTIVER LOGADO COMO FRANQUEADO

        var resp = await api.post('buscar_interesses',{  // BUSCA NO DB OS PRODUTOS QUE ESTÃO NO CARRINHO E OS PRODUTOS FAVORITADOS
          "usuario": sessionStorage['login'],
          "loja": sessionStorage['loja'],
        }).then((response) => {
          return response
        })  
        // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
          // 'fav' -> VAZIO POIS NADA ESTÁ FAVORITADO A PEDIDO DO DEPARTAMENTO DE MARKETING
          
          // 'car' -> LISTA COM OS PRODUTOS NO CARRINHO
              // CADA ITEM DE 'car' É UM DICIONÁRIO COM AS CHAVES
              // 'id' -> STRING COM O ID DO PRODUTO
              // id -> DICIONÁRIO COM OS DETALHES DO PRODUTO COM AS CHAVES
                // 'carrinho' -> INT COM A QUANTIDADE DE ITENS DESSE PRODUTO NO CARRINHO
                // 'estoque' -> INT COM QUANTOS PRODUTOS AINDA RESTAM EM ESTOQUE
                // 'img' -> STRING COM A URL DA IMAGEM DO PRODUTO
                // 'preco' -> FLOAT COM O PREÇO UNITÁRIO DO PRODUTO
          
          // 'session' -> STRING COM O ID DA SESSÃO GERADA PELA PAGSEGURO PARA REALIZAR A TRANSAÇÃO        
        
        if(resp){  // CASO EXISTAM PRODUTOS NO CARRINHO SALVOS NO DB
          setCarrinho(resp['data']['car']) // DEFINE O ESTADO DO CARRINHO
          var produtoscarrinho = []
          for(var i = 0; i < resp['data']['car'].length; i++){  // ADICIONA AS INFORMAÇÕES NA LISTA DE IDS DE PRODUTOS NO CARRINHO
            produtoscarrinho.push(resp['data']['car'][i]['id'])
          }          

          var sessao = []  // COLOCAR NA SESSÃO OS PRODUTOS NO CARRINHO ENCONTRADOS NO DB
          resp['data']['car'].forEach(function (element){
            var item = JSON.stringify(element)
            sessao.push(item)
          })
          sessionStorage['comprar'] = sessao.join(';')  // NOTA -> SEPARADOS POR ;

        }
        else{  // CASO NÃO EXISTAM PRODUTOS SALVOS NO DB
          setCarrinho([])  // DEFINE O ESTADO COMO VAZIO
        }        
        
      }

      console.log(resp)
    }
    else{  // CASO O USUÁRIO NÃO ESTEJA LOGADO
      var carrinho_list = []
      var prods_carrinho = []

      if(sessionStorage['comprar']){  // VERIFICA SE EXISTE ALGUM PRODUTO NO CARRINHO NA SESSAO
        sessionStorage['comprar'].split(';').forEach(function (element){
          var item = JSON.parse(element)
          carrinho_list.push(item)
          prods_carrinho.push(item['id'])
        })

        setCarrinho(carrinho_list)  // DEFINE O ESTADO DO CARRINHO COM OS PRODUTOS ENCONTRADOS
      }
      else{  // CASO NÃO ENCONTRE NADA NA SESSÃO
        setCarrinho([])  // DEFINE OS ESTADOS COMO VAZIO
      }
    }
  }


  async function search_produto(produto){  // FUNÇÃO PARA BUSCAR NO DB OS DETALHES DO PRODUTO
    // FUNÇÃO CHAMADA PELO ONLOAD DESTA PÁGINA

    // RECEBE COMO PARÂMETRO:
      // 'produto' -> STRING DO ID DO PRODUTO QUE VAI SER BUSCADO NO DB

    var resp = await api.post('buscar_produto_detalhes',{  // BUSCA NO DB OS DETALHES DO PRODUTO
      "produto": produto,
      "id_loja": sessionStorage['loja'],
    }).then((response) => {
      return response
    })
    // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
      // 'data' ->  DICIONÁRIO COM AS CHAVES
        // 'ALTURA' -> FLOAT COM A ALTURA DO PRODUTO
        // 'DESC_PRODUTO' -> STRING COM A DESCRIÇÃO DO PRODUTO
        // 'ESPESSURA' -> FLOAT COM A ESPESSURA DO PRODUTO
        // 'GRUPO_PRODUTO' -> STRING COM O GRUPO DO PRODUTO
        // 'LARGURA' -> FLOAT COM A LARGURA DO PRODUTO
        // 'OBS_IDEIA' -> STRING COM A DESCRIÇÃO DETALHADA DO PRODUTO
        // 'PESO' -> FLOAT COM O PESO DO PRODUTO
        // 'PRECO1' -> FLOAT COM O PRECO DO PRODUTO

      // 'fotos' -> LISTA COM FOTOS DO PRODUTO
        // CADA ITEM DE 'fotos' É UMA STRING COM A URL DE UMA FOTO PARA O PRODUTO


    var dict_resp = {}  // DEFINE UM DICIONÁRIO COM TODOS OS DETALHES ENCONTRADOS
    dict_resp['ALTURA'] = resp.data.data.ALTURA
    dict_resp['DESC_PRODUTO'] = resp.data.data.DESC_PRODUTO
    dict_resp['ESPESSURA'] = resp.data.data.ESPESSURA
    dict_resp['ESTOQUE_LOJA'] = resp.data.data.ESTOQUE_LOJA
    dict_resp['GRUPO_PRODUTO'] = resp.data.data.GRUPO_PRODUTO
    dict_resp['LARGURA'] = resp.data.data.LARGURA
    dict_resp['OBS_IDEIA'] = resp.data.data.OBS_IDEIA
    dict_resp['PESO'] = resp.data.data.PESO
    var preco = resp.data.data.PRECO1
  

    // FORMATA O PRECO (FORMATO XX.Y PARA XX,YY)
    preco = preco.toString()

    var preco_lista = preco.split('.')
    
    if(preco_lista.length === 2){
        var cents = preco_lista[1]
        
        if(cents.length === 1){
            cents = cents + '0'
        }
        if(cents.length > 2){
            cents = cents.slice(0, 2)
        }

        preco_lista[1] = cents
    }
    else if (preco_lista.length === 1){
        cents = '00'
        preco_lista.push(cents)
    }

    var preco_final = preco_lista.join(',')
    dict_resp['PRECO1'] = preco_final



    setFotos(resp.data.fotos)  // DEFINE AS FOTOS NO ESTADO DA PÁGINA
    setDetalhes([dict_resp])  // DEFINE OS OUTROS DETALHES NO ESTADO DA PÁGINA
    
    document.getElementById('loader').classList.add('d-none')  // ESCONDE LOADER
    document.getElementById('form-produto').classList.remove('d-none')  // MOSTRA FOTOS 
    document.getElementById('form-detalhes').classList.remove('d-none')  // MOSTRA OUTROS DETALHES
  }    


  // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
    // 'ContinuarComprando' -> VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME
    // 'Loader' -> APARECE ENQUANTO OS PRODUTOS NÃO SÃO CARREGADOS
    // 'ItensComprados' -> ABA LATERAL DIREITA DO CARRINHO
    // 'Carousel' -> COMPONENTE NATIVO DO REACT PARA GIRAR AS FOTOS

  return (
    <div>
       <ContinuarComprando />
      <div className="pt-35vh" id="loader">
        <Loader />
      </div>

      <div>
          <ItensComprados props={carrinho} callback={carrinho_de_compras}/> 
      </div>      

      <div class='mt-5'>
        <div id='form-produto' class='custom-container start-page card-checkout d-none'>
          {detalhes.map((block) => (
            <div>
              <div class="preco montserrat negrito fonte-x-large border-bottom my-2">
                {block.DESC_PRODUTO} - R$ {block.PRECO1}
              </div>  
            </div>
          ))}
          
          <Carousel>            
              {fotos.map((fotos) => (
                <div class="picture-carrossel">
                  <img src={fotos} class="h-100" alt="Foto"></img>
                  
                </div>
              ))}     
          </Carousel> 
          

       </div>

      </div>

      <div class='mt-5 pb-5'>
        <div id='form-detalhes' class='custom-container card-checkout mt-5 d-none'>
          {detalhes.map((block) => (
            <div>
              <div class="verde montserrat m-1 border-bottom">
                Espessura: {block.ESPESSURA*100} cm
              </div>
              <div class="verde montserrat m-1 border-bottom">
                Altura: {block.ALTURA*100} cm
              </div>
              <div class="verde montserrat m-1 border-bottom">
                Largura: {block.LARGURA*100} cm
              </div>
              <div class="verde montserrat m-1 border-bottom">
                Peso: {block.LARGURA*100} g
              </div>
              <div class="verde montserrat m-1 border-bottom">
                Estoque: {block.ESTOQUE_LOJA} itens restantes
              </div>              
            </div>    
          ))}

       </div>

      </div>      

    </div>
  )
}


export default Detalhe;